import React from "react";
import PropTypes from "prop-types";

const { REACT_APP_PUBLIC_URL } = process.env;

const InnerBgComp = (props) => {
  const { classes, bgImg } = props;

  return (
    <div
      className={`banner-top-img ${bgImg || classes ? classes : "remove-grad"}`}
      style={
        bgImg
          ? {
              backgroundImage: `url('${REACT_APP_PUBLIC_URL}/img/home-banner-img.png')`,
            }
          : null
      }
    ></div>
  );
};

InnerBgComp.propTypes = {
  classes: PropTypes.string,
  bgImg: PropTypes.bool,
};

export default InnerBgComp;
